import { useState } from 'react';
import './moreButton.css';

type Props = {
  onClick: (newValue: boolean) => void;
};

const MoreButton = ({ onClick }: Props) => {
  const [currentState, setCurrentState] = useState(true);

  const handleClick = () => {
    setCurrentState(!currentState);
    if (onClick) {
      onClick(currentState);
    }
  };

  return (
    <button onClick={handleClick} className="more-button">
      {currentState ? 'More' : 'Less'}
    </button>
  );
};

export default MoreButton;
